import { Listener } from './types'

let closeListeners: Listener[] = []
let mountListeners: Listener[] = []

export const addCloseListener = (listener: Listener) => {
  closeListeners.push(listener)
}

export const removeCloseListener = (listener: Listener) => {
  closeListeners = closeListeners.filter(l => l !== listener)
}

export const fireCloseListeners = (frame: string) => {
  closeListeners.forEach(listener => listener(frame))
}

export const addMountListener = (listener: Listener) => {
  mountListeners.push(listener)
}

export const removeMountListener = (listener: Listener) => {
  mountListeners = mountListeners.filter(l => l !== listener)
}

export const fireMountListeners = (frame: string) => {
  mountListeners.forEach(listener => listener(frame))
}
